import TipsModal from '@features/tips/tips';
export default TipsModal;
